import { render, staticRenderFns } from "./ConstructorAside.vue?vue&type=template&id=de5e35a4&scoped=true&"
import script from "./ConstructorAside.vue?vue&type=script&lang=js&"
export * from "./ConstructorAside.vue?vue&type=script&lang=js&"
import style0 from "./ConstructorAside.vue?vue&type=style&index=0&id=de5e35a4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de5e35a4",
  null
  
)

export default component.exports